import axios from "axios";

export const NotificationService = {
  async getAll() {
    const response = await axios.get(
      `${process.env.REACT_APP_STRAPI_URL}/api/notifications`
    );

    const res = response.data.data;
    // console.log(res);

    const data = res.map((item) => ({
      id: item.id,
      title: item.attributes.title,
      details: item.attributes.details,
      createdAt: new Date(item.attributes.createdAt).toLocaleString(),
      updatedAt: new Date(item.attributes.updatedAt).toLocaleString(),
      publishedAt: new Date(item.attributes.publishedAt).toLocaleString(),
    }));

    return data;
  },

  async getById(id) {
    const response = await axios.get(
      `${process.env.REACT_APP_STRAPI_URL}/api/notifications/${id}`
    );
    const res = response.data.data;

    const data = {
      id: res.id,
      title: res.attributes.title,
      details: res.attributes.details,
    };

    return data;
  },

  async create(data, jwt) {
    const response = await axios.post(
      `${process.env.REACT_APP_STRAPI_URL}/api/notifications`,
      { data },
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `bearer ${jwt}`,
        },
      }
    );

    return response.data;
  },

  async update(id, data, jwt) {   
    const response = await axios.put(
      `${process.env.REACT_APP_STRAPI_URL}/api/notifications/${id}`,
      { data },
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `bearer ${jwt}`,
        },
      }
    );

    return response.data;
  },

  async delete(id, jwt) {
    const response = await axios.delete(
      `${process.env.REACT_APP_STRAPI_URL}/api/notifications/${id}`,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `bearer ${jwt}`,
        },
      }
    );

    return response.data;
  },
};
